export default __webpack_public_path__ + "static/media/pro.a34c5eea.gif";